export default "/images/aa5330cd5b5ea0c2a0c7ba2f2cd24fc4.png";